<template>
  <v-main>
    <MainMenu />
    <Header />
    <MyAccountContent :nextUrl="previousRoute" />
    <Footer />
  </v-main>
</template>

<script>
import MainMenu from "@/components/common/MainMenu";
import Header from "@/components/MyAccount/Header";
import MyAccountContent from "@/components/MyAccount/MyAccountContent";
import Footer from "@/components/common/Footer";
export default {
  name: "MyAccount",
  data() {
    return {
      previousRoute: null,
    };
  },
  components: { Footer, MyAccountContent, Header, MainMenu },
  created() {
    this.previousRoute = this.$route.query.nextUrl;
  },
  mounted() {
    console.log("Previous route");
    console.log(this.previousRoute);
    //console.log(this.$route.query.reloaded);
    if ("true" === this.$route.query.reload) {
      window.location.href = "?nextUrl=" + this.previousRoute;
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log("to");
    console.log(to);
    console.log("from");
    console.log(from);
    console.log("next");
    console.log(next);
    console.log("nextUrl");
    next();
  },
};
</script>

<style scoped></style>
